import React, { useEffect, useState } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import { MyDomain } from "../../App";

const textFieldStyles = {
  "& .MuiInput-underline:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.5,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:hover:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.8,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#6366f1",
    borderBottomWidth: "1px",
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
  },
};
export default function AdminTownsCreate() {
  const { User, Token } = useAppContext();

  const [height, width] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [height]);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [Town, setTown] = useState("");
  const handleCreateTown = async () => {
    if (Town === "") {
      return;
    }
    const data = {
      town: Town,
      citizen: "he",
      //direction: "Haifa and Carmel region",
    };

    try {
      const response = await axios.post(`${MyDomain}Towns/CreateTown`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log(response.data);
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      alert("Invalid credentials. Please try again.");
    }
  };
  return (
    <div>
      <>
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>Town name</a>
        </div>
        <TextField
          id="standard-basic"
          label="Town name"
          variant="standard"
          name="Town"
          style={{
            paddingBottom: 30,
            width: "100%",
            fontSize: 10,
          }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" },
          }}
          value={Town}
          onChange={(e) => setTown(e.target.value)}
          sx={textFieldStyles}
        />
      </>
      <button
        style={{
          //marginTop: 20,
          backgroundColor: "#27272a",
          color: "#fff",
          border: "none",
          //padding: "10px 20px",
          cursor: "pointer",
          fontSize: "16px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 50,
        }}
        onClick={() => {
          handleCreateTown();
        }}
      >
        <a onClick={() => {}} style={{ cursor: "pointer" }}>
          Create town
        </a>
      </button>
    </div>
  );
}
